import { VolumesTabView } from '@valiant/ui-shared'
import type { MonthlyVolumeData } from '@valiant/ui-shared'
import { useGetMonthlyVolumesQuery } from '../../generated/graphql'

interface VolumesTabProps {
  groupId?: string
  companyId?: string
  searchTerm?: string
}

export function VolumesTab({ groupId, companyId, searchTerm }: VolumesTabProps = {}) {
  // Use backend filtering for volumes by group or company
  const [{ data: volumesData, fetching: volumesLoading }] = useGetMonthlyVolumesQuery({
    variables: {
      filter:
        groupId || companyId
          ? {
              ...(groupId && { groupId }),
              ...(companyId && { companyId }),
            }
          : undefined,
    },
  })

  const monthlyVolumes: MonthlyVolumeData[] = (volumesData?.getMonthlyVolumes || []).map(
    (volume) => ({
      month: volume.month,
      totalUsd: volume.totalUsd,
      totalUsdRaw: volume.totalUsdRaw,
      mints: volume.mints.map((mint) => ({
        mint: mint.mint,
        symbol: mint.symbol,
        volume: mint.volume,
      })),
    }),
  )

  return (
    <VolumesTabView
      searchTerm={searchTerm}
      monthlyVolumes={monthlyVolumes}
      loading={volumesLoading}
      showExportButton={true}
    />
  )
}
